/* eslint-disable import/no-cycle */
import Vue from 'vue';
import Vuex from 'vuex';

import VuexReset from '@ianwalter/vuex-reset';

import getters from './getters';
import mutations from './mutations';

import account from '@/modules/account/store';
import authentication from '@/modules/authentication/store';
import campaigns from '@/modules/campaigns/store';
import campaignMatches from '@/modules/campaignMatches/store';
import content from '@/modules/content/store';
import reporting from '@/modules/reporting/store';
import showcase from '@/modules/showcase/store';
import share from '@/modules/share/store';
import storage from '@/modules/storage/store';
import templates from '@/modules/templates/store';
import trackers from '@/modules/trackers/store';
import reportsGenerator from '@/modules/ReportsGenerator/store';

Vue.use(Vuex);

const store = new Vuex.Store({
  plugins: [VuexReset()],
  modules: {
    authentication,
    campaigns,
    campaignMatches,
    content,
    account,
    reporting,
    showcase,
    share,
    storage,
    templates,
    trackers,
    reportsGenerator,
  },
  state: {
    globalMessage: {
      type: '',
      message: '',
    },
    currencyMap: {},
  },
  getters,
  mutations,
});
export default store;
